import { Link } from "@heroui/react";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { TableBuilder } from "@/app/components/tables/tableBuilder";
import { FaArrowRightToBracket } from "react-icons/fa6";
import { api } from "@/api";
import { useNavigate } from "react-router-dom";
import useErrorHandling from "@/hooks/useErrorHandling";
import { Renter } from "@/api/renters";
import { ColumnType } from "@/app/components/tables/tableTypes";
import { useTour } from "@/hooks/useTour";
import {
  businessProfileLinks,
  Links,
} from "@/app/components/navigation/links/Links";

export function RentersUsersPage() {
  const [renters, setRenters] = useState<Renter[] | null>(null);
  const handleError = useErrorHandling();

  const navigate = useNavigate();

  useTour(7);

  useEffect(() => {
    api.renters
      .list()
      .then((response) => {
        setRenters(response.data);
      })
      .catch((err) => {
        const { errorMessage } = handleError(err);
        toast.error(errorMessage);
      });
  }, []);

  return (
    <>
      <div className="flex flex-col md:flex-row gap-4 w-full">
        <Links links={businessProfileLinks("/dashboard/renters")} />
        <div className="flex-grow bg-white dark:bg-zinc-900 rounded-xl border-2 border-foreground-200 dark:border-foreground-100 p-4">
          <div className="flex flex-row justify-between w-full items-center mb-4">
            <div className="flex flex-row gap-4 items-center">
              <span className="font-medium" id="renters-title">
                Арендаторы
              </span>
            </div>
          </div>
          <div className="flex flex-col gap-2 mb-2">
            <div id="renters-table">
              <TableBuilder
                displayOptions={false}
                removeWrapper={true}
                isFullScreen={true}
                columns={[
                  {
                    label: "Название",
                    key: "display_name",
                    type: ColumnType.Custom,
                    sortable: true,
                    render(value, row) {
                      return (
                        <Link
                          size="sm"
                          className="text-foreground"
                          href={`/dashboard/renters/${row.id}`}
                          showAnchorIcon
                        >
                          {value}
                        </Link>
                      );
                    },
                  },
                  {
                    label: "ОГРН",
                    key: "orgn",
                    type: ColumnType.String,
                  },
                  {
                    label: "ИНН",
                    key: "inn",
                    type: ColumnType.String,
                  },
                  {
                    label: "Владелец",
                    key: "holder",
                    type: ColumnType.User,
                  },
                  {
                    label: "Номер телефона",
                    key: "phone_number",
                    type: ColumnType.String,
                  },
                  {
                    label: "Email",
                    key: "email",
                    type: ColumnType.String,
                  },
                  {
                    label: "Действия",
                    key: "actions",
                    type: ColumnType.Actions,
                    actions: [
                      {
                        icon: <FaArrowRightToBracket />,
                        onClick(_value, row) {
                          navigate("/dashboard/renters/" + row.id);
                        },
                      },
                    ],
                  },
                ]}
                data={renters || []}
                defaultSortDescriptor={{
                  column: "display_name",
                  direction: "ascending",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
